import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isNumber } from "util";
import { changeCartQuantity, confirmCartItems } from "../../store/cart";
import debounce from "lodash/debounce";
import shop from "../../api/shop";
import { getTranslate } from "react-localize-redux";

const CartQuantityInput = ({
  quantity,
  cartProduct,
  changeCartQuantity,
  saveCartQuantity,
  customer,
  actionBar,
  translate
}) => (
  <input
    type="number"
    min="1"
    value={quantity}
    onChange={e => {
      changeCartQuantity(e.target.value, cartProduct);
      saveCartQuantity(e.target.value, cartProduct, customer, actionBar);
      e.stopPropagation();
    }}
    className="cartBar__item__body__quantity"
    placeholder={translate(
      "molecules.containers.cartQuantityInput.quantiy_shorcode"
    )}
    aria-label="Quantity Component"
    aria-describedby="basic-addon2"
  />
);

CartQuantityInput.propTypes = {
  quantity: PropTypes.number.isRequired,
  cartProduct: PropTypes.array,
  changeCartQuantity: PropTypes.func,
  saveCartQuantity: PropTypes.func,
  customer: PropTypes.array,
  actionBar: PropTypes.string,
  translate: PropTypes.func
};

const mapStateToProps = ({ common, locale, customer }) => ({
  translate: getTranslate(locale),
  customer: common.user.personal.id,
  actionBar: customer.actionOnCustomer
});

const mapDispatchToProps = dispatch => ({
  changeCartQuantity: (val, cartProduct) => {
    if (isNumber(parseInt(val))) {
      cartProduct.quantity = parseInt(val);
      dispatch(changeCartQuantity(cartProduct));
    }
  },
  saveCartQuantity: debounce((val, cartProduct, customer, actionBar) => {
    if (isNumber(parseInt(val))) {
      dispatch(
        confirmCartItems(
          cartProduct.id,
          customer,
          cartProduct.price.toString(),
          actionBar
        )
      );
    }
  }, 500)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartQuantityInput);



// WEBPACK FOOTER //
// ./src/molecules/containers/CartQuantityInput.js